import { useMutation } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import { Lock } from "lucide-react";
import { useState } from "react";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { authApi } from "@/lib/api";

export function LoginForm({ onSuccess }: { onSuccess: () => void }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const login = useMutation({
    mutationFn: () => authApi.login(email.trim(), password),
    onSuccess,
  });

  return (
    <main className="flex min-h-screen items-center justify-center px-5 py-10">
      <form
        className="surface w-full max-w-sm p-7"
        onSubmit={(event) => {
          event.preventDefault();
          login.mutate();
        }}
      >
        <div className="flex flex-col items-center text-center">
          <div className="flex size-14 items-center justify-center rounded-full bg-primary/12 text-primary">
            <Lock className="size-6" />
          </div>
          <h1 className="mt-4 text-xl font-semibold tracking-tight">Adminläge</h1>
          <p className="mt-1 text-sm text-muted-foreground">
            Logga in för att hantera personal, tider och löneexport.
          </p>
        </div>

        <div className="mt-6 space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="email">E-postadress</Label>
            <Input
              id="email"
              type="email"
              autoComplete="username"
              autoFocus
              required
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              className="h-12"
            />
          </div>

          <div className="space-y-1.5">
            <Label htmlFor="password">Lösenord</Label>
            <Input
              id="password"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              className="h-12"
            />
          </div>

          {login.isError && (
            <p className="rounded-2xl bg-destructive/10 px-4 py-3 text-sm text-destructive">
              {(login.error as Error).message}
            </p>
          )}

          <Button
            type="submit"
            className="press h-12 w-full rounded-2xl text-base"
            disabled={login.isPending}
          >
            {login.isPending ? "Loggar in…" : "Logga in"}
          </Button>
        </div>

        <Link
          to="/"
          className="mt-5 block text-center text-sm text-muted-foreground hover:underline"
        >
          Tillbaka till panelen
        </Link>
      </form>
    </main>
  );
}
